import axios from 'axios';
import { useContext } from 'react';
import useSWR from 'swr';
import { TokenContext } from '../context/TokenContext';
import config from '../config';

const afasFetcher = async (input) => {
  const [path, queryStringParameters, token] = input;
  return axios
    .get(`${process.env.REACT_APP_ENV === "development" || process.env.NODE_ENV === "development"
        ? config.BASE_URL_DEV
        : config.BASE_URL
      }${path}`, {
      headers: {
        Authorization: token,
      },
      params: queryStringParameters,
    })
    .then((res) => res.data);
};

function useAfasData(path, queryStringObj = {}, { enabled = true } = {}) {
  const token = useContext(TokenContext);
  // Only fetch if the `enabled` flag is true
  const shouldFetch = enabled && path;

  // eslint-disable-next-line no-unused-vars
  const { data, error, mutate } = useSWR(shouldFetch ? [path, queryStringObj, token] : null, afasFetcher, {
    errorRetryCount: 3,
    focusThrottleInterval: 15000,
  });

  let errorMessage;
  let errorType = '';
  let statusCode = 200;

  if (error && error?.response) {
    const errorData = error.response.data;
    errorType = 'UnexpectedError';
    statusCode = errorData.statusCode;
    errorMessage = 'ERROR';
  }
  return {
    mutate,
    data,
    isLoading: !error && !data,
    errorMessage,
    statusCode,
    errorType,
  };
}

export default useAfasData;
